var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pipe } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CommonProvider } from '../../providers/common/common';
import { TranslateService } from '@ngx-translate/core';
var DateFormatPipe = /** @class */ (function () {
    function DateFormatPipe(datepipe, comProv, translate) {
        this.datepipe = datepipe;
        this.comProv = comProv;
        this.translate = translate;
    }
    DateFormatPipe.prototype.transform = function (date, format) {
        if (!date) {
            return;
        }
        var date_rep = date.replace(/-/g, '/');
        if (date_rep.indexOf('/') == -1 && date_rep.length == 8) {
            var yyyy = date_rep.substring(0, 4);
            var mm = date_rep.substring(4, 6);
            var dd = date_rep.substring(6, 8);
            date_rep = yyyy + '/' + mm + '/' + dd;
        }
        var date_for;
        var service_data = this.comProv.getService();
        if (service_data['option']['is_multilingual']) {
            var browser_lang = this.translate.getBrowserLang();
            if (browser_lang == 'en') {
                if (format.indexOf('##') == -1) {
                    date_for = this.datepipe.transform(date_rep, 'mediumDate', '', browser_lang);
                }
                else {
                    date_for = this.datepipe.transform(date_rep, 'E. MMM d, yyyy', '', browser_lang);
                }
                return date_for;
            }
        }
        // 曜日
        var weeks = ['日', '月', '火', '水', '木', '金', '土'];
        var date_obj = new Date(date_rep);
        var no = date_obj.getDay();
        var youbi = weeks[no];
        format = format.replace('##', youbi);
        date_for = this.datepipe.transform(date_rep, format);
        return date_for;
    };
    DateFormatPipe = __decorate([
        Pipe({
            name: 'dateFormat',
        }),
        __metadata("design:paramtypes", [DatePipe,
            CommonProvider,
            TranslateService])
    ], DateFormatPipe);
    return DateFormatPipe;
}());
export { DateFormatPipe };
//# sourceMappingURL=date-format.js.map


// WEBPACK FOOTER //
// ./src/pipes/date-format/date-format.ts.pre-build-optimizer.js